/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { ETransportErrorMessageVO } from './etransport-error-message-vo.model';
import { Maybe } from '@irian-ro/util-functions';
import { ETransportListMessageVO } from './etransport-list-message-vo.model';

export class ETransportListResponseVO extends JSONable{
    mesaje: ETransportListMessageVO[] = [];
    errors: ETransportErrorMessageVO[] = [];

    serial: Maybe<string> | undefined = undefined;
    cui: Maybe<string> | undefined = undefined;
    titlu: Maybe<string> | undefined = undefined;
    dateResponse: Maybe<string> | undefined = undefined;
    executionStatus: Maybe<number> | undefined = undefined;
    traceId: Maybe<string> | undefined = undefined;
}
